import { useQuery } from "@tanstack/react-query";
import type { RoleResponse } from "@offertli/shared";
import { apiGet } from "../../lib/api.js";
import { usePermissions } from "../../lib/auth.js";
import { ErrorPanel, LoadingPanel } from "../shared.js";
import { ProjectRolesPanel } from "./project-roles.js";
import { RolesPanel } from "./users.js";

export function RoleSettingsPanel() {
  const canManageProjectRoles = usePermissions().has(
    "projects.manage_role_permissions",
  );
  const roles = useQuery({
    queryKey: ["roles"],
    queryFn: () =>
      apiGet<{ data: RoleResponse[] }>("/roles").then(
        (response) => response.data,
      ),
  });
  if (roles.isLoading) return <LoadingPanel />;
  if (roles.error) return <ErrorPanel error={roles.error} />;
  return (
    <div className="space-y-6">
      <RolesPanel roles={roles.data ?? []} loading={false} />
      {canManageProjectRoles ? <ProjectRolesPanel /> : null}
    </div>
  );
}
